import * as React from "react"
import { useTranslation } from "react-i18next"

import StatefulField from "shared/components/StatefulField"
import { INutrition } from "shared/hubrise/models"

import { NoneOption } from "./Styles"

const NONE = "__none__"

interface SelectWithNoneProps<Key extends "allergens" | "additives"> {
  nutrition: INutrition | null
  updateNutrition: (patch: Partial<INutrition>) => void
  listKey: Key
  options: { label: string; value: string }[]
  label: string
}

const SelectWithNone = <Key extends "allergens" | "additives">({
  nutrition,
  updateNutrition,
  listKey,
  options,
  label,
}: SelectWithNoneProps<Key>): JSX.Element => {
  const { t } = useTranslation()

  const nutritionList = nutrition !== null ? nutrition[listKey] : null

  return (
    <StatefulField.Select
      initialValue={nutritionList !== null ? (nutritionList.length > 0 ? nutritionList : [NONE]) : []}
      label={label}
      withMargin
      options={[
        { label: t(`nutrition.component.composition.none.${listKey}`), value: NONE },
        ...options.sort((a, b) => a.label.localeCompare(b.label)),
      ]}
      renderOption={(option) => (option.value === NONE ? <NoneOption>{option.label}</NoneOption> : option.label)}
      onSelectOption={(optionValue, currentValues) =>
        optionValue === NONE ? [NONE] : [...currentValues.filter((v) => v !== NONE), optionValue]
      }
      onChange={(values) => {
        if (values.includes(NONE)) {
          updateNutrition({ [listKey]: [] })
        } else if (values.length > 0) {
          updateNutrition({ [listKey]: values as INutrition[Key] })
        } else {
          updateNutrition({ [listKey]: null })
        }
      }}
      isMulti
      sortValuesForSave={true}
      withClearValue={true}
    />
  )
}

export default SelectWithNone
